import Vue from "vue";

Vue.directive("start-owl", {
    bind(el, binding)
    {
        $(function()
        {

            if (binding.value != 5)
            {
                if (window.matchMedia("(max-width: 768px)").matches)
                {
                    const owl = $(el);

                    // do not render, if no html element is inside of the carousels container
                    if (owl.children().length)
                    {
                        const type = binding.value ? binding.value : 1;

                        let resp = [1, 2, 3, 4, 4];

                        let lazy = true;

                        let autoW = false;

                        let posCenter = false;

                        let loop = true;

                        let dots = true;

                        let respOff = false;

                        let autoP = false;

                        switch (type)
                        {
                        case 2:
                            resp = [1, 1, 2, 2, 3];
                            lazy = false;
                            autoW = false;
                            dots = false;
                            posCenter = true;
                            autoP = true;
                            break;
                        case 3:
                            resp = [3, 4, 5, 6, 7];
                            lazy = false;
                            autoW = true;
                            posCenter = true;
                            dots = false;
                            break;
                        case 4:
                            lazy = false;
                            loop = false;
                            respOff = true;
                            break;
                        }

                        const owlSettings = {
                            dots: dots,
                            lazyLoad: lazy,
                            loop: loop,
                            margin: 10,
                            autoWidth: autoW,
                            center: posCenter
                        };

                        if (autoP)
                        {
                            owlSettings["autoplay"] = true;
                            owlSettings["autoplayTimeout"] = 2000;
                            owlSettings["autoplayHoverPause"] = false;
                        }

                        if (!respOff)
                        {
                            owlSettings["items"] = resp[4];
                            owlSettings["responsive"] = {
                                0: {
                                    items: resp[0]
                                },
                                576: {
                                    items: resp[1]
                                },
                                768: {
                                    items: resp[2]
                                },
                                992: {
                                    items: resp[3]
                                },
                                1200: {
                                    items: resp[4]
                                }
                            };
                        }
                        else
                        {
                            owlSettings["items"] = 1;
                        }

                        owl.owlCarousel(owlSettings);
                    }
                }
            }
            else
            {
                const owl = $(el);

                // do not render, if no html element is inside of the carousels container
                if (owl.children().length)
                {
                    owl.owlCarousel({
                        dots: true,
                        items: 3,
                        margin: 10,
                        autoWidth: false
                    });
                }
            }
        });
    }
});
